import "core-js/modules/es.object.assign.js";

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from 'react';
import Svg, { Path } from 'react-native-svg';

function Moon(props) {
  return React.createElement(Svg, _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24"
  }, props), React.createElement(Path, {
    fillRule: "evenodd",
    d: "M11.94 3.638a1 1 0 00-.862-1.634 10.006 10.006 0 00-9.034 9.034m9.896-7.4l-.031.047a5.998 5.998 0 001.326 8.301 5.992 5.992 0 007.13 0 1 1 0 011.59.896c-.51 5.5-5.377 9.545-10.877 9.034-5.5-.511-9.545-5.378-9.034-10.879m7.229-6.596a8.009 8.009 0 00-5.237 6.781 7.996 7.996 0 007.226 8.702 7.997 7.997 0 008.26-5.238 7.992 7.992 0 01-7.477-1.092 8.003 8.003 0 01-2.772-9.153z",
    clipRule: "evenodd"
  }));
}

export default Moon;